const { routes }: any = window

interface PredictiveSearchParams {
  searchQuery: string
  sectionParam: string
  limitParam: string
  fieldsParam: string
}

class PredictiveSearchAPI {
  get(params: PredictiveSearchParams): Promise<string> {
    const query = this.prepareQuery(params)

    return fetch(query).then(response => response.text())
  }

  prepareQuery(params: PredictiveSearchParams): string {
    const { searchQuery, sectionParam, limitParam, fieldsParam } = params
    const baseUrl = routes.predictive_search_url

    return `${baseUrl}?q=${searchQuery}&${limitParam}&${sectionParam}&${fieldsParam}`
  }
}

export default PredictiveSearchAPI
